module.exports = __webpack_public_path__ + "static/media/youth.786ae460.png";